/* Una píldora surface con las opciones adentro; la elegida es blanca con sombra xs. */
.grupo {
  --_h: var(--h-control-md);
  --_aire: var(--s-2);
  display: inline-flex;
  gap: var(--s-2);
  height: var(--_h);
  padding: var(--_aire);
  border-radius: var(--r-control);
  background: var(--surface-sunken);
}
.grupo[data-size="sm"] {
  --_h: var(--h-control-sm);
}
/* A lo ancho: una grilla con todas las opciones del mismo tamaño y el borde de la píldora por adentro. */
.grupo[data-full-width] {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  width: 100%;
  box-sizing: border-box;
  border: var(--bw-hair) solid var(--border-hair);
}
.grupo[data-full-width] .opcion {
  height: calc(var(--_h) - 2 * var(--_aire) - 2 * var(--bw-hair));
  padding-inline: var(--s-3);
  overflow: hidden;
  text-overflow: ellipsis;
}
.opcion {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--s-3);
  height: calc(var(--_h) - 2 * var(--_aire));
  padding: 0 var(--s-6);
  border: none;
  border-radius: var(--r-control);
  background: transparent;
  color: var(--text-muted);
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition:
    background var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}
.grupo[data-size="sm"] .opcion {
  padding: 0 var(--s-5);
  font-size: var(--fs-3xs);
}
/* Sólo icono: cuadrada, del alto de la opción. */
.opcion[data-icon-only] {
  width: calc(var(--_h) - 2 * var(--_aire));
  padding: 0;
}
.grupo[data-tone="outline"] .opcion[data-icon-only] {
  width: calc(var(--_h) - 2 * var(--_aire) - 2 * var(--bw-hair));
}
/* Elegida con outline: el icono en violeta, como el mock. */
.grupo[data-tone="outline"] .opcion[aria-checked="true"][data-icon-only] {
  color: var(--text-brand);
  background: var(--surface-brand-soft);
  box-shadow: none;
}
.opcion[aria-checked="true"] {
  background: var(--surface-card);
  color: var(--text-strong);
  box-shadow: var(--sh-xs);
}
/* Outline: píldora blanca con borde; la elegida lleva un lavado accent-50 con anillo accent-100 por adentro. */
.grupo[data-tone="outline"] {
  box-sizing: border-box;
  border: var(--bw-hair) solid var(--border-hair);
  background: var(--surface-card);
}
.grupo[data-tone="outline"] .opcion {
  height: calc(var(--_h) - 2 * var(--_aire) - 2 * var(--bw-hair));
}
.grupo[data-tone="outline"] .opcion[aria-checked="true"] {
  background: var(--surface-brand-faint);
  box-shadow: inset 0 0 0 var(--bw-hair) var(--border-brand-soft);
}
@media (hover: hover) {
  .opcion:hover:enabled:not([aria-checked="true"]) {
    color: var(--text-strong);
  }
}
.opcion:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
.opcion:disabled {
  color: var(--control-disabled-text);
  cursor: not-allowed;
}
@media (prefers-reduced-motion: reduce) {
  .opcion {
    transition: none;
  }
}
